import Cookies from "js-cookie";

export function setTokenCookie(token) {
	Cookies.set("token", token, { expires: 1 / 24 }); // La cookie expirará en 1 hora
}

export function getTokenCookie() {
	return Cookies.get("token");
}

export function removeTokenCookie() {
	Cookies.remove("token");
}

export function setAdminTypeCookie(adminType) {
	Cookies.set("adminType", adminType, { expires: 1 / 24 }); // La cookie expirará en 1 hora
}

export function getAdminTypeCookie() {
	return Cookies.get("adminType");
}

export function removeAdminTypeCookie() {
	Cookies.remove("adminType");
}